import AbstractController from '@src/services/ControllersRepository/AbstractController';
import ImportViewNavigator from '@src/components/_views/configurable/import-view/ImportViewNavigator';

export default class Import extends AbstractController {
    protected controllerName = 'Abstract';

    protected availableActions = ['import'];

    protected getDefaultImportComponent() {
        return ImportViewNavigator;
    }
}
